import AlertListContainer from '../containers/AlertListContainer'
import OverlayAboutTile from './OverlayAboutTile'
import OverlayColumn from './OverlayColumn'
import OverlayTagTile from './OverlayTagTile'
import OverlayTile from './OverlayTile'
import OverlayTileColumn from './OverlayTileColumn'
import OverlayTileHeading from './OverlayTileHeading'
import OverlayTileOptionLink from './OverlayTileOptionLink'
import OverlayWorkspaceTile from './OverlayWorkspaceTile'
import PermissionGuard from './PermissionGuard'
import RichText from './RichText'
import ShareLinkPopover from './ShareLinkPopover'
import WorkspaceSelectorContainer from '../containers/WorkspaceSelectorContainer'
import selectSearchHighlights from '../selectors/selectSearchHighlights'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class ReportOverlay extends Component {
  static propTypes = {
    onAddToWorkspace: PropTypes.func.isRequired,
    permissions: PropTypes.object.isRequired,
    report: PropTypes.object.isRequired,
    searchHighlights: PropTypes.array,
    tags: PropTypes.array.isRequired,
    workspaces: PropTypes.array.isRequired
  }

  render() {
    const {
      onAddToWorkspace,
      permissions,
      report,
      searchHighlights,
      tags,
      workspaces
    } = this.props

    return (
      <div className="view-display">
        <AlertListContainer clearOnUnmount={true} />
        <OverlayTile>
          <iframe
            className="iframe-contain"
            src={`${report.shareUrl}?iframe=true`}
            frameBorder={0}
          />
        </OverlayTile>
        <OverlayColumn align="left">
          <div className="editor-tab-bar">
            <div className="tab-item selected">
              {I18n.t('Project Background')}
            </div>
          </div>
          <OverlayTile>
            <RichText
              searchHighlights={selectSearchHighlights(
                searchHighlights,
                'projectObjectives'
              )}
              text={report.objectives}
            />
          </OverlayTile>
        </OverlayColumn>
        <OverlayColumn align="right">
          <OverlayTile className="clearfix">
            <OverlayTileHeading icon="settings" title="Options" />
            <OverlayTileColumn align="left">
              <PermissionGuard
                permissions={permissions}
                object="workspace"
                operation="edit"
              >
                <WorkspaceSelectorContainer onAddToWorkspace={onAddToWorkspace}>
                  <OverlayTileOptionLink
                    icon="file-add"
                    title="Add to Workspace"
                  />
                </WorkspaceSelectorContainer>
              </PermissionGuard>
              <ShareLinkPopover tip={report.shareUrl}>
                <OverlayTileOptionLink title="Share" icon="share" />
              </ShareLinkPopover>
            </OverlayTileColumn>
          </OverlayTile>
          <OverlayAboutTile
            date={report.insertDt}
            details={{
              'Project Name': report.projectName,
              Description: report.description,
              'Number of pages': report.pageCount
            }}
            heading="About this Report"
            searchHighlights={selectSearchHighlights(searchHighlights, 'title')}
            title={report.reportTitle}
            verb="Created"
          />
          <OverlayWorkspaceTile workspaces={workspaces} />
          <OverlayTagTile
            searchHighlights={selectSearchHighlights(
              searchHighlights,
              'tagNames'
            )}
            tags={tags}
          />
        </OverlayColumn>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/ReportOverlay.js